import { Component } from '@angular/core';
import {
  ActivatedRoute,
  Router
} from '@angular/router';
import { NavPageInfo } from '../../model/page-info';
import { NavService } from '../../nav.service';
import { OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
})
export class CustomBreadcrumbComponent implements OnDestroy {

  navPages: NavPageInfo[] = [];
  sub: Subscription;
  constructor(
    private navService: NavService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {
    this.navService.getRouterPagesInfo(router, activatedRoute).subscribe(p => {
      this.navPages = p;
    });
    this.sub = this.navService.navPagesChanged.subscribe(np => {
      this.navPages = np;
    });
  }

  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
}
